/* eslint-disable max-classes-per-file */
import { BaseTrackEvent } from '@/modules/core/app/models/BaseTrackEvent';

export class SmartCampaignCreate extends BaseTrackEvent {
  /**
   * @type {string}
   */
  static name = 'SmartCampaigns - Create';

  /**
   * @var {string}
   */
  static smart_campaign_id;

  /**
   * @var {string}
   */
  static smart_campaign_name;

  /**
   * @var {string}
   */
  static data_source;

  /**
   * @var {array}
   */
  static multi_data_source;

  /**
   * @var {string}
   */
  static campaign_type;

  /**
   * @var {string}
   */
  static data_view;

  /**
   * @var {string}
   */
  static assigned_to_client;

  /**
   * @var {string}
   */
  static dynamic_list;

  static build(model) {
    return new SmartCampaignCreate({
      smart_campaign_id: model.id,
      smart_campaign_name: model.name,
      data_source: model.service_name,
      data_view: model.dataview_display,
      multi_data_source: model.service_ids,
      assigned_to_client: model.customer_name,
      dynamic_list: model.dynamic_mapping,
      campaign_type: model.campaign_type,
    });
  }
}

export class SmartCampaignEdit extends BaseTrackEvent {
  /**
   * @type {string}
   */
  static name = 'SmartCampaigns - Edit';

  /**
   * @var {string}
   */
  static smart_campaign_id;

  /**
   * @var {string}
   */
  static smart_campaign_name;

  /**
   * @var {string}
   */
  static data_source;

  /**
   * @var {array}
   */
  static multi_data_source;

  /**
   * @var {string}
   */
  static data_view;

  /**
   * @var {string}
   */
  static assigned_to_client;

  /**
   * @var {string}
   */
  static dynamic_list;

  static build(model) {
    return new SmartCampaignEdit({
      smart_campaign_id: model.id,
      smart_campaign_name: model.name,
      data_source: model.service_name,
      multi_data_source: model.service_ids,
      data_view: model.dataview_display,
      assigned_to_client: model.customer_name,
      dynamic_list: model.dynamic_mapping,
    });
  }
}

export class SmartCampaignDelete extends BaseTrackEvent {
  /**
   * @type {string}
   */
  static name = 'SmartCampaigns - Delete';

  /**
   * @var {string}
   */
  static smart_campaign_id;

  /**
   * @var {string}
   */
  static smart_campaign_name;

  static build(model) {
    return new SmartCampaignDelete({
      smart_campaign_id: model.id,
      smart_campaign_name: model.name,
    });
  }
}

export class SmartCampaignCopy extends BaseTrackEvent {
  /**
   * @type {string}
   */
  static name = 'SmartCampaigns - Copy';

  /**
   * @var {string}
   */
  static smart_campaign_id;

  /**
   * @var {string}
   */
  static smart_campaign_name;

  static build(model) {
    return new SmartCampaignCopy({
      smart_campaign_id: model.id,
      smart_campaign_name: model.name,
    });
  }
}
